// extracted by mini-css-extract-plugin
export default {"backButton":"_8fdc5b85bb _7683b20207 cf98221031 _164c1dcbf3"};